import React from "react";
import { useMediaQuery } from "react-responsive";

interface ResponsiveComponentProps {
  mobileComponent: React.ReactNode;
  webComponent: React.ReactNode;
}

const ResponsiveComponent: React.FC<ResponsiveComponentProps> = ({
  mobileComponent,
  webComponent,
}) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  return <>{isMobile ? mobileComponent : webComponent}</>;
};

export default ResponsiveComponent;
